import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import ivyPlayer from '@/commons/ivyPlayer.vue';
let SnapshotPic = class SnapshotPic extends Vue {
    constructor() {
        super(...arguments);
        this.pageNow = 1;
        this.videoPlaying = false;
    }
    pageChange(index) {
        this.pageNow = index + 1;
    }
    playVideo() {
        // 播放视频
        this.videoPlaying = true;
        document.querySelector('.ivy-btn-play').click();
    }
    closeVideo() {
        // 关闭播放
        this.videoPlaying = false;
        this.newTime = new Date().getTime();
    }
};
tslib_1.__decorate([
    Prop()
], SnapshotPic.prototype, "cover_pics", void 0);
tslib_1.__decorate([
    Prop()
], SnapshotPic.prototype, "cover_video_url", void 0);
SnapshotPic = tslib_1.__decorate([
    Component({
        components: {
            ivyPlayer,
        },
    })
], SnapshotPic);
export default SnapshotPic;
